import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GlobalVariables } from '../../../common/global-variables';
import { createToolTip, prettyUserName } from '../../../common/utils/utils';
import { JobConstants } from '../../../common/utils/job-constants';

@Pipe({name: 'username'})
export class UserNamePipe implements PipeTransform {
    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }
    transform(value): any {
        if ( value ) {
            return prettyUserName(value);
        } else {
            return '-';
        }
    }
}

@Pipe({name: 'jobType'})
export class JobTypePipe implements PipeTransform {
    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }
    private computeWorkFlows = [
        JobConstants.WORKFLOW_JOB_TYPES.CREATE_ORGANIZATION_JOB,
        JobConstants.WORKFLOW_JOB_TYPES.UPDATE_ORGANIZATION_JOB,
        JobConstants.WORKFLOW_JOB_TYPES.DELETE_ORGANIZATION_JOB,
        JobConstants.WORKFLOW_JOB_TYPES.CREATE_ORG_VDC_JOB,
        JobConstants.WORKFLOW_JOB_TYPES.UPDATE_ORG_VDC_JOB,
        JobConstants.WORKFLOW_JOB_TYPES.DELETE_ORG_VDC_JOB ,
        JobConstants.WORKFLOW_JOB_TYPES.UPDATE_ORG_VDC_STORAGE_PROFILES_JOB
    ];
    transform(value): any {
        if ( value.jobType === JobConstants.SERVICES['NetworkingServiceJobV1'] ) {
            for ( let i = 0; i < 7; ++i ) {
                if ( value.workflowType === this.computeWorkFlows[i] ) {
                    return this.translate.instant(JobConstants.JOB_TYPES['ComputeJob']);
                }
            }
        }
        if ( JobConstants.JOB_TYPES.hasOwnProperty(value.jobType) ) {
            return this.translate.instant(JobConstants.JOB_TYPES[value.jobType]);
        } else {
            return this.translate.instant('activityLog.unknownService');
        }
    }
}

@Pipe({
    name: 'workflowType'
})
export class WorkflowTypePipe implements PipeTransform {
    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }
    transform(value): any {
        if ( JobConstants.WORKFLOW_TYPES.hasOwnProperty(value) ) {
            return this.translate.instant(JobConstants.WORKFLOW_TYPES[value]);
        } else {
            return this.translate.instant('activityLog.unknownJobType');
        }
    }
}

@Pipe({
    name: 'jobStatus'
})
export class JobStatusPipe implements PipeTransform {
    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }
    transform(value): any {
        if ( value ) {
            if ( value.isDone ) {
                if ( value.didFail ) {
                    return '<span class=\'label label-danger\'>' +
                        this.translate.instant('activityLog.statuses.failed') + '</span>';
                } else {
                    return '<span class=\'label label-success\'>' +
                        this.translate.instant('activityLog.statuses.success') + '</span>';
                }
            } else {
                return '<span class=\'label label-info\'>' + this.translate.instant('activityLog.statuses.running') + '</span>';
            }
        } else {
            return '<span> </span>';
        }
    }
}

@Pipe({
    name: 'jobDescription'
})
export class JobDescriptionPipe implements PipeTransform {
    constructor(public translate: TranslateService) {
        translate.use(GlobalVariables.LOCALE);
    }
    transform(value): any {
        let returnString = '', tooltipString = value;
        if ( value && value.length > 70 ) {
            let str2 = value.substring(0, 66) + '...';
            returnString = createToolTip('<span>' + str2 + '</span>', tooltipString, 'tooltip tooltip-lg tooltip-right');
        } else {
            returnString = tooltipString;
        }
        return returnString;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/activity-log/custom-pipes.pipe.ts